// extracted by mini-css-extract-plugin
export default {"addressAction":"s5-z","loading":"t5-z"};